import { Empty, Spin } from 'antd';
import { createElement } from 'react';
;
const EmptyComponent = (props) => {
    const { loading, empty, children } = props;
    console.log(children);
    return (createElement(Spin, { spinning: loading },
        createElement("div", null, empty || (typeof empty == 'undefined') ?
            createElement(Empty, null) :
            children)));
};
export default EmptyComponent;
